module.exports = __webpack_public_path__ + "static/media/lock_darkbleu.59ecfbef.svg";